import React, { useEffect, useRef, useState } from "react";

const BISSystemOverviewSection = ({ modules }) => {
  const sectionRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  return (
    <section className="bis-system-overview-section py-5" ref={sectionRef}>
      <div className="container">
        <h2 className="text-center fw-bold mb-5 text-dark text-uppercase">
          System Overview
        </h2>
        <div className="row g-4">
          {modules.map((module, i) => (
            <div className="col-12 col-sm-6 col-lg-3" key={i}>
              <div
                className={`bis-module-card shadow-sm ${
                  isVisible
                    ? i % 2 === 0
                      ? "slide-from-bottom"
                      : "slide-from-top"
                    : ""
                }`}
              >
                <div className="bis-module-card-header d-flex align-items-center gap-2 p-3">
                  <i className={`bi ${module.icon} text-white fs-4`}></i>

                  <h5 className="mb-0 text-white fw-bold">{module.title}</h5>
                </div>
                <div className="bis-module-card-body">
                  <ul className="module-card-list mb-0 ps-0">
                    {module.features.map((feature, j) => (
                      <li key={j}>
                        <i className="bi bi-check2 text-dark me-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BISSystemOverviewSection;
